import OrganizationDetailHeader from './OrganizationDetailHeader';

export default OrganizationDetailHeader;
